import { render, staticRenderFns } from "./RazPlusLogin.vue?vue&type=template&id=49217e9d&scoped=true"
import script from "./RazPlusLogin.vue?vue&type=script&lang=js"
export * from "./RazPlusLogin.vue?vue&type=script&lang=js"
import style0 from "./RazPlusLogin.vue?vue&type=style&index=0&id=49217e9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49217e9d",
  null
  
)

export default component.exports